/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import styles from "./registrationScreen.module.css";
import { ajaxLink } from "../self-assesment/CONSTANTS";

const Verify = () => {
  const history = useHistory();

  // ── User data from localStorage ──
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const [email, setEmail] = useState(userData.email || "");
  const phone = userData.phone || "";

  // ── OTP input ──
  const [code, setCode] = useState("");
  const [errCode, setErrCode] = useState("");

  // ── Change-email modal ──
  const [showChangeEmail, setShowChangeEmail] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [errEmail, setErrEmail] = useState("");

  // ── Notification banner (resent code) ──
  const [bannerVisible, setBannerVisible] = useState(false);

  // ── External redirect link (self-assessment flow) ──
  const [externalLink, setExternalLink] = useState("");
  const [showClosePage, setShowClosePage] = useState(false);

  // ─── Effects ────────────────────────────────

  useEffect(() => {
    /* Check if OTP already verified; if not, send code */
    // fetch(ajaxLink + "/user/checkOtpVerified", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: JSON.parse(localStorage.getItem("userData"))?.token,
    //   },
    // }).catch(() => resendCode(true)); // on error -> send the code
    resendCode();
  }, []);

  // ─── Helpers ────────────────────────────────

  /** Validate email string with a simple regex */
  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v?.trim());

  /** Refresh auth header from localStorage (token may update between calls) */
  //   const refreshAuthHeader = () => {
  //     axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData"))?.token;
  //   };

  // ─── API calls ──────────────────────────────

  /**
   * Resend OTP to current email.
   * @param {boolean} onLoad — when true (called on mount), suppress banner
   */
  const resendCode = (onLoad = false) => {
    const firstName = JSON.parse(localStorage.getItem("userData"))?.first_name || "Virdio User";

    fetch(ajaxLink + "/user/resendOtp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("userData"))?.token,
      },
      body: JSON.stringify({ firstName, email }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.responseCode === 200) {
          if (!onLoad) setBannerVisible(true);
        }
      })
      .catch((err) => console.error("resendOtp error:", err));
  };

  /**
   * Update email address, then resend OTP to the new address.
   * Closes the change-email modal on success.
   */
  const submitNewEmail = () => {
    if (!isValidEmail(newEmail)) {
      setErrEmail("Please enter a valid email address.");
      return;
    }
    setErrEmail("");

    const firstName = JSON.parse(localStorage.getItem("userData"))?.first_name || "Virdio User";

    fetch(ajaxLink + "/user/setNewEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("userData"))?.token,
      },
      body: JSON.stringify({
        firstName,
        oldEmail: email,
        newEmail: newEmail.trim().toLowerCase(),
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.responseCode === 200) {
          /* Update email in localStorage */
          const stored = JSON.parse(localStorage.getItem("userData"));
          stored.email = newEmail;
          localStorage.setItem("userData", JSON.stringify(stored));

          setEmail(newEmail);
          setShowChangeEmail(false);
          setNewEmail("");
          setBannerVisible(true);
          resendCode();
        }
      })
      .catch((err) => {
        if (err.response?.data?.errorData?.emailErr) {
          setErrEmail(err.response.data.errorData.emailErr);
        }
      });
  };
  const verifyOtp = () => {
    fetch(ajaxLink + "/user/verifyOtp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("userData"))?.token,
      },
      body: JSON.stringify({ code }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.responseCode !== 200) return;

        const data = res.responseData;

        /* Self-assessment / external site flow */
        if (data.token && data.self_user === 1) {
          const fromSite = localStorage.getItem("fromSite") || window.location.origin;
          setExternalLink(`${fromSite}/?userId=${data.id}&userToken=${data.token}`);
          return;
        }

        // if (data.userType === 1) {
        //   history.push("/initial_questionare");
        //   localStorage.removeItem("company_id");
        // } else if (data.userType === 2) {
        // }
        //   history.push("/dashboard");
      })
      .catch((err) => {
        if (err.response?.data?.errorData?.codeErr) {
          setErrCode(err.response.data.errorData.codeErr);
        }
      });
  };
  /**
   * Open external recovery plan in a new tab.
   * After 5 seconds show the "you can close this tab" screen.
   */
  const openExternalLink = () => {
    setTimeout(() => setShowClosePage(true), 5000);
    window.location.replace(externalLink);
  };

  // ─── Render: close/thank-you page ───────────
  if (showClosePage) {
    return (
      <div className={styles.verClosePage}>
        <div className={styles.verCloseContainer}>
          <p className={styles.verCloseMessage}>Thank you for taking the Guided Self-Assessment.</p>
          <p className={styles.verCloseNote}>You can close this tab when you are ready.</p>
          <p className={styles.verCloseSignature}>Myra &amp; The Virdio Health Team</p>
        </div>
      </div>
    );
  }

  // ─── Render: main verify page ────────────────
  return (
    <div className={styles.verPageWrap}>
      {/* ── Resent-code notification banner ── */}
      {bannerVisible && (
        <div className={styles.verBanner}>
          <div className={styles.verBannerIcon} />
          <div className={styles.verBannerText}>
            A verification code has been resent to
            <span>{" {" + email + "}. "}</span>
            Please enter it once you receive the email
          </div>
          <div className={styles.verBannerDismiss} onClick={() => setBannerVisible(false)}>
            Dismiss
          </div>
        </div>
      )}

      {/* ── OTP entry form (hidden once external link is set) ── */}
      {!externalLink && (
        <div className={`${styles.verContainer} ${bannerVisible ? styles.verContainerBannerActive : ""}`}>
          {/* Back button */}
          <div className={`previous_btn ${styles.verBackBtn}`} onClick={() => history.push("/register")}>
            <div className={styles.back_arrow_btn} />
          </div>

          {/* Card */}
          <div className={styles.verCard}>
            <div className={styles.verTitle}>Verify your account</div>

            <div className={styles.verExplain}>
              We've sent an email with a code to <span>[{email}]</span> and SMS to mobile number <span>[{phone}]</span> to verify your Virdio Health account.
            </div>

            {/* OTP input */}
            <div className={styles.verFieldLabel}>Security code</div>
            <input type="text" tabIndex={1} className={styles.verCodeInput} onChange={(e) => setCode(e.target.value)} />
            {errCode && <div className={styles.verError}>{errCode}</div>}

            {/* Resend code */}
            <div className={styles.verActionRow}>
              <div className={styles.verActionDesc}>Didn't receive the code?</div>
              <div className={styles.verActionLink} onClick={() => resendCode()}>
                Resend Code
              </div>
            </div>

            {/* Change email */}
            <div className={styles.verActionRow}>
              <div className={styles.verActionDesc}>Wrong email?</div>
              <div className={styles.verActionLink} onClick={() => setShowChangeEmail(true)}>
                Change email address
              </div>
            </div>

            {/* Info tip */}
            <div className={styles.verInfoBox}>
              <div className={styles.verInfoInner}>
                <div className={styles.verInfoIconWrap}>
                  <div className={styles.verInfoIcon} />
                </div>
                <div className={styles.verInfoText}>Please make sure to check your tabs Updates, Promotions, Forums, and Spam Folder</div>
              </div>
            </div>

            {/* Continue button */}
            <button className={`${styles.verContinueBtn} ${code.length === 0 ? styles.verContinueBtnDisabled : ""}`} onClick={verifyOtp} tabIndex={2}>
              Continue
            </button>
          </div>
        </div>
      )}

      {/* ── Success card (self-assessment flow) ── */}
      {externalLink && (
        <div className={styles.verSuccessWrap}>
          <div className={styles.verSuccessModal}>
            {/* Checkmark icon */}
            <div className={styles.verSuccessIconWrap}>
              <svg fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
              </svg>
            </div>

            <h2 className={styles.verSuccessHeading}>Account Created!</h2>
            <p className={styles.verSuccessSubheading}>Your personalized recovery plan is ready.</p>

            {/* Decorative wave */}
            <svg className={styles.verSuccessDecorLine} viewBox="0 0 104 12" fill="none">
              <path d="M103.39 10.211C103.39 10.211 72.841 2.35103 51.644 2.35103C30.447 2.35103 0.609985 10.211 0.609985 10.211" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>

            {/* CTA */}
            <button className={styles.verSuccessCtaBtn} onClick={openExternalLink}>
              Access My First Week
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* ── Change-email modal ── */}
      {showChangeEmail && (
        <>
          {/* Backdrop */}
          <div className={styles.verModalOverlay} onClick={() => setShowChangeEmail(false)} />

          <div className={styles.verModalWrap}>
            <div className={styles.verModalCard}>
              {/* Close icon */}
              <div className={styles.verModalClose} onClick={() => setShowChangeEmail(false)} />

              <div className={styles.verModalTitle}>Change Email Address</div>

              <div className={styles.verModalExplain}>Enter email below. We'll send you an email with a code to this new address.</div>

              <div className={styles.verModalFieldLabel}>Email Address</div>
              <input type="text" className={styles.verModalInput} placeholder="Enter Email Address" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />

              {errEmail && <div className={styles.verError}>{errEmail}</div>}

              <div className={styles.verModalSendBtn} onClick={submitNewEmail}>
                Send
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Verify;
